import React, { useState, useEffect } from 'react';
import { emailRegEx, noSpaceRegex, sidebarData } from '../../Constants'
import SidebarItems from './SidebarItems'
import { Link } from 'react-router-dom';
import logo from '../../Assets/Images/logo.png';
import togglelogo from '../../Assets/Images/logotoggle.png';
import { useForm } from 'react-hook-form';
import ModalBox from '../modals/ModalBox';
import { MakeAxiosRequest } from '../../utils/handler';
import { SwalError, SwalSuccess } from '../SwalFns';
import { useSelector } from 'react-redux';
function Sidebar() {
   const [invitemodalShow, setInviteModalShow] = useState(false);
   const {
      register,
      handleSubmit,
      formState: { errors },
      reset
    } = useForm();
    
  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const user = localStorage.getItem('user');
  const data = JSON.parse(user)
  const authUser = useSelector((state) => state?.auth?.user?.userDetails);
  const handleInviteClose = () => {
    reset();
   setInviteModalShow(false);

 };

 const showInviteModal = () => {
   setInviteModalShow(true);
 };

  const toggleSidebar = () => {
     setSidebarVisible(!isSidebarVisible);
  };
  const [sideBarMenu, setSideBarMenu] = useState([]);
  useEffect(() => {
     setSideBarMenu(sidebarData);
   }, [data, sidebarData]);

   const submitInvitation = async (data) => {
      try {
        const response = await MakeAxiosRequest("post", "invitation", data);
        // console.log(response);
        if (response.status == 1) {
          handleInviteClose();
          SwalSuccess({ msg: response.message });
        } else if (response.status == 0) {
          SwalError({ msg: response.message });
        } else {
          // setError('phone_number', { type: 'custom', message: response.message });
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    };
   
  useEffect(() => {
     if (isSidebarVisible) {
        document.body.classList.remove('sidebar-toggled');
        document.getElementById('accordionSidebar').classList.remove('toggled');
     } else {
        document.body.classList.add('sidebar-toggled');
        document.getElementById('accordionSidebar').classList.add('toggled');
     }
  }, [isSidebarVisible]);
  return (
    <>
     <div class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion justify-content-between" id="accordionSidebar">
            <div class="left-nav">
               
               <ul class="">
               {sideBarMenu?.filter(item => item.is_show || item?.phone == data.userDetails?.phone_number).map( (item,index) => (
                  <SidebarItems item={item} key={index}/>
               ))}
               </ul>
            </div>

         <div>
            <ul class="p-0">
               <li class="pb-3">
                  <a class="" href="javascript:void(0)" onClick={showInviteModal}>
                     <div class="inviteBody">
                        <span class="material-symbols-outlined">group_add</span>
                        <h6>Invite a friend</h6>
                        <small>Send invitations to download the app</small>
                     </div>
                  </a>
               </li>
                <li class="nav-item side-nav-item d-md-inline toggle-item">
                  <a class="nav-link mb-2" href="javascript:void(0)" onClick={toggleSidebar} id="sidebarToggle">
                     <span class="material-symbols-outlined"> close_fullscreen </span>
                     <p>Toggle Sidenav</p>
                  </a>
               </li>
            </ul>
               
         </div>
      </div>
      <ModalBox
          isShow={invitemodalShow}
          handleClose={handleInviteClose}
          className="close-btn"
          modalSize="md"
          hasData={true}
        >
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <h3 class="">Invite a friend</h3>
                <h6 class="gray mb-4 px-md-5 px-2">Send invitations to download the app</h6>
                <form onSubmit={handleSubmit(submitInvitation)}>
                <div class="form-group floating-label mt-4">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      {...register("name", {
                        required: "Please enter name",
                        pattern: {
                          value: noSpaceRegex,
                          message: "Please enter a valid name",
                      },
                      })}
                    />
                    <label htmlFor="tax">Name</label>
                    {errors.name && (
                      <span className="error">{errors.name.message}</span>
                    )}
                  </div>
                  <div class="form-group floating-label mt-4">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      {...register("email", {
                        required: "Please enter email",
                        pattern: {
                           value: emailRegEx,
                           message: "Please enter a valid email address",
                       },
                       space: {
                        value: noSpaceRegex,
                        message: "Please enter a valid email address",
                      },
                      })}
                    />
                    <label htmlFor="tax">Email Address</label>
                    {errors.email && (
                      <span className="error">{errors.email.message}</span>
                    )}
                  </div>
                  <div class="btnAlignBox">
                <button
                  type="button"
                  onClick={handleInviteClose}
                  className="btn btn-outline-primary w-100"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary rounded-pill w-100 p-2"
                >
                  Send
                </button>
              </div>
                </form>
              </div>
             
            </div>
          </div>

        </ModalBox>
    </>
  )
}

export default Sidebar